module.exports = __webpack_public_path__ + "static/media/addIcon.83a4d314.svg";